import get from "lodash/get"

/**
 * Retrieves the short name of a specific type of address component from a Google Maps suggestion.
 *
 * @param {Object} suggest - The Google Maps suggestion object.
 * @param {string} type - The type of address component to retrieve.
 * @returns {string} - The short name of the address component, or an empty string if not found.
 *
 * @see ``` // there might be more address component types, these types are just what I found
 * in one of google's responses
 * const addressComponentTypes = [
 * `street_number`,
 * `route`,
 * `neighborhood`,
 * `locality`,
 * `administrative_area_level_1`,
 * `administrative_area_level_2`,
 * `country`,
 * `postal_code`,
 * ] ```
 */
export default (suggest, type) => {
  const comps = get(suggest, `gmaps.address_components`, []).filter(
    (comp) => comp.types.length > 0 && comp.types[0] === type,
  )
  return comps.length > 0 ? comps[0].short_name : `` /* (() => {
 return `You must use one of the following 'types': ${addressComponentTypes.join(`, `)}`
 })() */
}
